import { translations, type Language, type TranslationKey } from './translations';
import { editorTranslationsEn } from './editorTranslations';
import type { I18nContextValue } from './useI18n';

type TranslationParams = Record<string, string | number>;

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : match,
  );
}

/**
 * Значение контекста языка по языку и сеттеру. Чистая функция: `I18nProvider` оборачивает её
 * в `useMemo`, а `PublicLanguageScope` строит значение для поддерева с принудительным языком.
 */
export function createI18nValue(
  language: Language,
  setLanguage: (language: Language) => void,
): I18nContextValue {
  return {
    language,
    locale: language === 'ru' ? 'ru-RU' : 'en-US',
    setLanguage,
    t: (key: TranslationKey, params?: TranslationParams) =>
      interpolate(translations[language][key], params),
    et: (source: string, params?: TranslationParams) =>
      interpolate(language === 'en' ? (editorTranslationsEn[source] ?? source) : source, params),
  };
}
